import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { NDfAccount } from '@df/account/df-account.config';
import { History } from '@df/session/api/history/history';

export const accountHistoryResolver: ResolveFn<History> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(History).load(false, inject(NDfAccount.OPTIONS).historyLoadQty);
};
